interface ServerConfig {
  baseApiEndpoints: string[];
  ltapiEndpoints: string[];
  sportsEndpoints?: string[];
  imEndpoints?: string[];
  quick3dEndpoints?: string[];
  lqiEndpoints?: string[];
  loiEndpoints?: string[];
  environment: string;
}

interface ServersConfig {
  [env: string]: ServerConfig;
}

export const SERVERS_CONFIG: ServersConfig = {
  prod: {
    baseApiEndpoints: [
      'aHR0cHM6Ly9hcGkuc3VwZXJnYW1lMTIzLnh5eg==', // https://api.supergame123.xyz
      'aHR0cHM6Ly9hcGkuc2cyMjMzNjZ3dy5jb20=', // https://api.sg223366ww.com
      'aHR0cHM6Ly9hcGkuc2cyMjMzNjZ3Z28uY29t', // https://api.sg223366wgo.com
      'aHR0cHM6Ly9hcGkuc2cyMjU1Lnh5eg==', // https://api.sg2255.xyz
      'aHR0cHM6Ly9hcGkuc2cyMjY2Lnh5eg==', // https://api.sg2266.xyz
    ],
    ltapiEndpoints: [
      'aHR0cHM6Ly9sdGFwaS5nYW1lNzEyLmNvbQ==', // https://ltapi.game712.com
      'aHR0cHM6Ly9hcGkuZ2FtaW5nMjI1NS5uZXQ=', // https://api.gaming2255.net
      'aHR0cHM6Ly9hcGkuZ2FtaW5nMjI1NS54eXo=', // https://api.gaming2255.xyz
    ],
    sportsEndpoints: [
      'aHR0cHM6Ly9hcGkuc3BvcnQyMjU1Lnh5eg==', // https://api.sport2255.xyz
      'aHR0cHM6Ly9hcGkuc3BvcnQyMjY2Lnh5eg==', // https://api.sport2266.xyz
      'aHR0cHM6Ly9hcGkuc3BvcnQyMjc3Lnh5eg==', // https://api.sport2277.xyz
      'aHR0cHM6Ly9hcGkuc3BvcnQyMjg4Lnh5eg==', // https://api.sport2288.xyz
      'aHR0cHM6Ly9hcGkuc3BvcnQyMjk5Lnh5eg==', // https://api.sport2299.xyz
    ],
    imEndpoints: [],
    quick3dEndpoints: [
      'aHR0cHM6Ly9hcGkucGljazIyNTUueHl6', // https://api.pick2255.xyz
      'aHR0cHM6Ly9hcGkucGljazIyNjYueHl6', // https://api.pick2266.xyz
      'aHR0cHM6Ly9hcGkucGljazIyNzcueHl6', // https://api.pick2277.xyz
      'aHR0cHM6Ly9hcGkucGljazIyODgueHl6', // https://api.pick2288.xyz
      'aHR0cHM6Ly9hcGkucGljazIyOTkueHl6', // https://api.pick2299.xyz
    ],
    lqiEndpoints: [
      'aHR0cHM6Ly9hcGkucXVpY2syMjU1Lnh5eg==', // https://api.quick2255.xyz
      'aHR0cHM6Ly9hcGkucXVpY2syMjY2Lnh5eg==', // https://api.quick2266.xyz
      'aHR0cHM6Ly9hcGkucXVpY2syMjc3Lnh5eg==', // https://api.quick2277.xyz
      'aHR0cHM6Ly9hcGkucXVpY2syMjg4Lnh5eg==', // https://api.quick2288.xyz
      'aHR0cHM6Ly9hcGkucXVpY2syMjk5Lnh5eg==', // https://api.quick2299.xyz
    ],
    loiEndpoints: [
      'aHR0cHM6Ly9hcGkub2ZjMjI1NS54eXo=', // https://api.ofc2255.xyz
      'aHR0cHM6Ly9hcGkub2ZjMjI2Ni54eXo=', // https://api.ofc2266.xyz
      'aHR0cHM6Ly9hcGkub2ZjMjI3Ny54eXo=', // https://api.ofc2277.xyz
      'aHR0cHM6Ly9hcGkub2ZjMjI4OC54eXo=', // https://api.ofc2288.xyz
      'aHR0cHM6Ly9hcGkub2ZjMjI5OS54eXo=', // https://api.ofc2299.xyz
    ],
    environment: 'prod',
  },
};

export type {ServerConfig, ServersConfig};
